<template lang="pug">
app-page( title="Управление судами региона" :fabItems="fabItems" )
  app-toolbar( :title="`Список судов региона ${ getRegionTitle }`" )
  app-empty-list( v-if="!regionHasCourt(regionId)" ) Список пуст
  app-group-animation
    app-group-item(v-for="court in getRegionCourts" :key="court.id" cols="4")
      expert-court-card( :court="court" :regionId="regionId" @clickCard="openCourtActionsDialog(court)" )

  expert-add-court-dialog( v-model="isAddCourtDialogOpened" @save="saveRegionCourt" )
  expert-edit-court-dialog( v-model="isEditCourtDialogOpened" ref="expertEditCourtDialog" :form="selectedCourt" @save="saveRegionCourt" )
  app-dialog( v-model="isActionsDialogOpened" :header="`Суд - ${selectedCourt.title}`" :items="actions" )
  app-dialog-confirm( v-model="isDelActionOpened" @confirm="confirmDeleteCourt(selectedCourt.id)" )
    app-card-title.mt-5 Вы точно хотите удалить суд - {{ selectedCourt.title }} ?
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ExpertAddCourtDialog from './dialogs/ExpertAddCourtDialog.vue'
import ExpertEditCourtDialog from './dialogs/ExpertEditCourtDialog.vue'
import ExpertCourtCard from './ExpertCourtCard.vue'
import { ExpertCourt } from './models/ExpertCourt.model'
import { ExpertRegion } from './models/ExpertRegion.model'
export default {
  name: 'ExpertCourts',

  components: {
    ExpertAddCourtDialog,
    ExpertEditCourtDialog,
    ExpertCourtCard
  },

  props: {
    regionId: { type: String, default: "" }
  },

  data() {
    return {
      isAddCourtDialogOpened: false,
      isEditCourtDialogOpened: false,
      isActionsDialogOpened: false,
      isDelActionOpened: false,
      selectedCourt: new ExpertCourt(),
    }
  },

  computed: {
    ...mapGetters('expert', ['getRegionById', 'regionHasCourt']),

    getRegionTitle() {
      return this.getRegionById(this.regionId)?.title ?? ""
    },

    getRegionCourts() {
      return this.getRegionById(this.regionId)?.courtCards ?? []
    },

    fabItems() {
      return [{ icon:'add', title:'Добавить суд', action: () => this.openAddCourtDialog()}]
    },

    actions () {
      return [
        { title: 'Редактировать', icon: 'edit', action: () => this.openEditCourtDialog() }, 
        { title: 'Удалить', icon: 'delete', action: () => this.openDeleteCourtDialog() }
      ]
    },
  },

  methods: {
    ...mapActions('expert', ['saveCourt', 'deleteCourt']),

    openAddCourtDialog() {
      this.isAddCourtDialogOpened = true
    },

    openCourtActionsDialog(court) {
      this.selectedCourt = court
      this.isActionsDialogOpened = true
    },

    openDeleteCourtDialog() {
      this.isDelActionOpened = true
    },

    openEditCourtDialog() {
      this.$refs.expertEditCourtDialog.show()
    },

    confirmDeleteCourt(id) {
      console.log(id);
      this.deleteCourt({ id: id, regionId: this.regionId })
    },

    saveRegionCourt(court) {
      console.log(court)
      let region = new ExpertRegion({ ...this.getRegionById(this.regionId), courtCards: [] })
      court.courtRegion = region
      this.saveCourt({ court: court, regionId: this.regionId })
    }
  }
}
</script>